"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _ResultHeader = _interopRequireDefault(require("./ResultHeader"));

var _ResultInfo = _interopRequireDefault(require("./ResultInfo"));

var _GradeTypeConstants = _interopRequireDefault(require("../../constants/GradeTypeConstants"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconResultSection =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(IconResultSection, _React$Component);

  function IconResultSection() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, IconResultSection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(IconResultSection)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getTickOrXIconClasses = function () {
      var gradeType = _this.props.gradeType;
      return (0, _classnames.default)({
        icon: true,
        'icon-check-circle': gradeType === _GradeTypeConstants.default.GOOD,
        'icon-delete-circle': gradeType === _GradeTypeConstants.default.BAD
      });
    };

    return _this;
  }

  (0, _createClass2.default)(IconResultSection, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return _react.default.createElement("div", {
        className: "flip-card-container"
      }, _react.default.createElement("div", {
        className: "left"
      }, _react.default.createElement("div", {
        className: this.getTickOrXIconClasses()
      })), _react.default.createElement("div", {
        className: "info"
      }, _react.default.createElement(_ResultHeader.default, props), _react.default.createElement(_ResultInfo.default, props)));
    }
  }]);
  return IconResultSection;
}(_react.default.Component);

exports.default = IconResultSection;
IconResultSection.propTypes = {
  gradeType: _propTypes.default.string,
  resultHeader: _propTypes.default.string,
  resultIcon: _propTypes.default.string
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/result/FlipCardResultSection.js
// module id = 300
// module chunks = 0